export default {
    id: 'violet',
    colors: ['#6B32C9', '#D0A3FF'],
};
